import { PATH } from '@/constants/path';
import { Banner, BlockStack, Box, Button, Collapsible } from '@shopify/polaris';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import RegularText from '../RegularText';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const NewPricingBanner = ({ isOpen, onClose }: Props) => {
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(isOpen);

  return (
    <Collapsible id={'pricing-banner'} open={dismissed}>
      <Banner
        title="You Asked, We Listened – Special Deals for Our Customers 🚀"
        onDismiss={() => {
          onClose();
          setDismissed(false);
        }}
      >
        <BlockStack gap={'200'}>
          <RegularText>
            📦 Thanks to your feedback, we’re rolling out new improvements! To celebrate, we’re offering a lower price on premium
            plans—so you can grow your business without extra costs. 🔥 This offer won’t last forever—grab it while you can! 🎉
          </RegularText>
          <Box>
            <Button onClick={() => navigate(PATH.PRICING)}>Enjoy new price</Button>
          </Box>
        </BlockStack>
      </Banner>
    </Collapsible>
  );
};
